import { Component, OnInit, ViewChild } from '@angular/core';

import { BehaviorSubject, Observable } from "rxjs";

import { UserTableService } from 'src/service/user.service';

import { CustomerService } from 'src/api/services';
import { User,Customer, CustomerSummary, MapLayerItem } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { MapLayerTableService } from 'src/service/map-layer.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { KeyValueConfig } from 'src/app/components/key-value-editor.ts/key-value-editor.component';


// todo: fix styles
// todo: install license

@Component({
  selector: 'app-map-layers',
  templateUrl: './map-layers.component.html',
  styleUrls: ['./map-layers.component.css']
})
export class MapLayersComponent implements OnInit {


  public geoJsonStyleConfig: KeyValueConfig[] = [{
      key: 'color',
      name: 'Colour',
      type: 'colour',
      min: null,
      max: null, 
      step: null
    },{
      key: 'weight',
      name: 'Line Weight',
      type: 'number',
      min: 0,
      max: 5,
      step: 1
    },{
      key: 'opacity',
      name: 'Opacity',
      type: 'number',
      min: 0,
      max: 1,
      step: 0.1
    }
  ];

  public item : MapLayerItem = {overwriteStyles: true} as MapLayerItem;
  public customers : CustomerSummary[];

  public remoteData: Observable<any[]>;

  constructor(
    public service: MapLayerTableService,
    public azureAuthService: AzureAuthService,
    private customerService: CustomerService,
    public app: ApplicationConfigService
    ) { 
    this.remoteData = this.service.remoteData;
    this.customerService.CustomerGetAllCustomers().subscribe(c => this.customers = c);
    app.customerChanged$.subscribe(cid => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {    
    if (this.azureAuthService.isGlobalViewer()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c => {           
          this.app.customers = c;//.filter(c=>c.active);          
        });
      }
    } 
    if (this.app.customerId == null) {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
    }
    this.service.get();
  }

  public getCustomerName(customerId: number) {
    for (var c of this.customers){
      if (c.customerId == customerId){
        return c.customerName;
      }
    }
    return customerId;
  }

  public clearItem(){
    this.item = {} as MapLayerItem;
  }

  public removeItem(item: MapLayerItem) {
    this.service.remove(item);
  }

  public updateItem() {
    this.service.update(this.item);
  }

  public copyLayer(layer: MapLayerItem){
    this.item = {
      customerId: layer.customerId,
      layerTypeId: layer.layerTypeId,
      tileSize: layer.tileSize,
      useProxy: layer.useProxy,
      visible: layer.visible,
      authToken: layer.authToken,
      path: layer.path,
      styles: layer.styles,
      fileLayerName: layer.fileLayerName,
      layerName: layer.layerName,
      layerType: layer.layerType,
      url: layer.url,
      overwriteStyles: layer.overwriteStyles
    } as MapLayerItem;
  }

  public addItem() {
    this.item.customerId = this.app.customerId;   
    this.service.add(this.item);
  }

  public updateStyles(item, styles){
    item.style = styles;
  }
}
